import AodObjectFactory from "../aodApi/object/AodObjectFactory";
import {pick, find, reject} from "lodash";
import {message} from "antd";
import {searchAndSave} from "../AodUi/aodHooks";
import {replaceElement} from "../Wizard/utils";

/*
todo ? which AOD Service
    - ideally AodService will only be used from a webpack
    - how to share single instance
    - standardize whether plain or AOD objects are stored in the model
 */


export default function Controller(aodService, model){
    this.aodObjectFactory = new AodObjectFactory(aodService);
    this.model = model;
    this.aodService = aodService;
}

// Actions that require use of AOD objects/items and/Or maintenance of the the model

// todo - be consistent about whether errors ar trapped here or by caller

Controller.prototype = {

    createAdvertiser: async function(advertiser){

        const advObj = this.aodObjectFactory.get('Advertiser', advertiser);
        const account = this.model.account.getOne('selected_account');

        const newAdvertiser = await advObj.create(account);
        // todo new model call storeInSet?
        this.model.advertiser.store(newAdvertiser);
        this.model.advertiser.addToSet('selected_account', newAdvertiser);
        return newAdvertiser;
    },

    updateAdvertiser: async function(advertiser){

        // todo - TEMP
        //  AOD barf on case equivalent name changes
        //  So use interim name
        let {name} = this.model.advertiser.get(advertiser.id);
        if (name.toLowerCase() === advertiser.name.toLowerCase() ) {

            name += " (\u200btemp\u200b)";
            const tempAdv = {
                ...advertiser,
                name,
                company: {
                    ...advertiser.company,
                    name
                }
            };
            console.log(`Temp Adv: ${name}`)

            const tempAdvObj = this.aodObjectFactory.get('Advertiser', tempAdv);
            const newTempAdvObj = await tempAdvObj.save();

            advertiser.recordVersion = newTempAdvObj.recordVersion;
            advertiser.company.recordVersion = newTempAdvObj.company.recordVersion;
        }

        const advObj = this.aodObjectFactory.get('Advertiser', advertiser);
        const newAdvertiser = await advObj.save();
        this.model.advertiser.update(newAdvertiser);
        return newAdvertiser;
    },

    deleteAdvertiser: async function(advertiser){
        const advObj = this.aodObjectFactory.get('Advertiser', advertiser);
        const result = await advObj.remove();
        this.model.advertiser.remove(advertiser);
    },

    uploadAdvertiserFile: async function(advertiser, file, options={}) {

        //todo check valid pair if in options
        const defaultOptions = {
            fileClass: 'INPUT',
            fileType: 'MATERIAL'
        };
        const advObj = this.aodObjectFactory.get('Advertiser', advertiser);
        const {managedFile: newFile} = await advObj.uploadFile(file, {...defaultOptions, ...options});

        if (newFile) {
            // todo - ?store file in model for advertiser
            //this.model.managedFile.store(newFile);
            // todo - ?check this set exists
            //this.model.managedFile.addToSet('selected_advertiser', newFile);
            return newFile;
        } else {
            throw new Error('File upload failed');
        }
    },

    getAdvertiser: async function(id){

        let advertiser = this.model.advertiser.get(id);
        if (!advertiser) {
            try {
                await this.loadAdvertisers();
                advertiser = this.model.advertiser.get(id);
            } catch (e) {
                console.error(e);
                message.error("Failed to reload advertisers!");
            }
        }
        return advertiser;
    },

    // todo ? uses a search ? timestamp results or use SWR so we don't keep re-getting results
    findAdvertiser: async function(where){
        let advList = this.model.advertiser.getAll();  // ?specific set
        let advertiser = find(advList, where);
        if (!advertiser) {
            try {
                await this.loadAdvertisers();
                advList = this.model.advertiser.getAll();
                advertiser = find(advList, where);
            } catch (e) {
                console.error(e);
                message.error("Failed to reload advertisers!");
            }
        }
        return advertiser;
    },

    loadAdvertisers: async function(){
        const setName = 'selected_account';
        const account = this.model.account.getOne(setName);
        return await searchAndSave({
            setName,
            model: this.model,
            aodService: this.aodService,
            itemType: 'advertiser',
            query:{
                searchBy: 'account',
                id: account.id
            }
        });
    },

    getSalesSheet: async function(id){
        // todo ?load from id call for objs
        const itemCall = this.aodService.itemCalls.salesSheet;
        try {
            const result = await itemCall.load(id);
            return itemCall.getRecord(result);
        } catch (e) {
            console.error(e);
            message.error("Failed to load Presentation!");
        }
    },

    loadSalesSheets: async function(advertiserId, setName='advertiser'){
        return await searchAndSave({
            setName,
            model: this.model,
            aodService: this.aodService,
            itemType: 'salesSheet',
            query:{
                searchBy: 'advertiser',
                id: advertiserId
            }
        });
    },

    findSalesSheet: async function(where){
        let ssList = this.model.salesSheet.getAll();  // ?specific set
        let salesSheet = find(ssList, where);
        if (!salesSheet) {
            try {
                await this.loadSalesSheets(where.advertiserId);
                ssList = this.model.salesSheet.getAll();
                salesSheet = find(ssList, where);
            } catch (e) {
                console.error(e);
                message.error("Failed to reload presentations!");
            }
        }
        return salesSheet;
    },

    createSalesSheet: async function(salesSheet, advertiser, {specAd, pdfUrl, contact, setName}={}){

        const ssObj = this.aodObjectFactory.get('SalesSheet', salesSheet);
        //todo check for advertiser on salesSheet
        //const advertiser = this.model.advertiser.getOne('selected_account');

        //const newSalesSheet = await ssObj.create(advertiser);
        if (advertiser && advertiser.id ){
            ssObj.advertiserId = advertiser.id;
        } //todo else error?

        if (specAd ){
            ssObj.specAd = specAd; //Special case allows inline create and attach of one ad
        }

        if (contact && contact.id ){
            ssObj.contactId = contact.id;
        }
        const newSalesSheet = await ssObj.create();

        if (pdfUrl && specAd && newSalesSheet.specAds.length===1) { // and there should be...
            await this.addFileToSpecAd(newSalesSheet.specAds[0], pdfUrl);
        }
        // deprecated
        if (setName) {
            this.model.salesSheet.addToSet(setName, newSalesSheet);
        }
        return newSalesSheet;
    },

    updateSalesSheet: async function(salesSheet, changes){
        //const changedSalesSheet = clone(salesSheet); // todo - ?shallow is that good enough
        //salesSheet.merge(changes);

        //todo - try this minimal approach ? make AodObject method
        const changesSalesSheet = this.aodObjectFactory.get('SalesSheet', {...changes, ...pick(salesSheet, 'id', 'recordVersion')});
        // todo trap old version error & retry - OK with just changes

        const newSalesSheet = await changesSalesSheet.save();
        // todo ? item or objects in model
        this.model.salesSheet.update(newSalesSheet);
        return newSalesSheet;
    },

    deleteSalesSheet: async function(salesSheet){
        const ssObj = this.aodObjectFactory.get('SalesSheet', salesSheet);
        const result = await ssObj.remove();
        this.model.salesSheet.remove(salesSheet);
    },


    createSpecAd: async function(specAd, salesSheet, pdfUrl){

        const saObj = this.aodObjectFactory.get('SpecAd', specAd);
        const ssObj = this.aodObjectFactory.get('SalesSheet', salesSheet);

        const newSpecAd = await saObj.create(ssObj);
        await this.addFileToSpecAd(newSpecAd, pdfUrl);

        ssObj.recordVersion = ssObj.recordVersion+.001;
        ssObj.specAds.unshift(newSpecAd);
        this.model.salesSheet.store(ssObj);

        return newSpecAd;
    },

    updateSpecAd:  async function(specAd, changes, pdfUrl){

        const changed = this.aodObjectFactory.get('SpecAd', {
            ...changes,
            ...pick(specAd, 'id', 'recordVersion')
        });
        // todo trap old version error & retry - OK with just changes

        if (pdfUrl) {
            await this.addFileToSpecAd(specAd, pdfUrl);
        }
        const newSpecAd = await changed.save();
        this.replaceSpecAdInSalesSheet(newSpecAd);
        return newSpecAd;
    },

    lockSpecAd:  async function(specAd) {

        const adObj = this.aodObjectFactory.get('SpecAd', pick(specAd, 'id', 'recordVersion'));

        const newSpecAd = await adObj.lock();
        this.replaceSpecAdInSalesSheet(newSpecAd);
        return newSpecAd;
    },

    unLockSpecAd:  async function(specAd) {

        const adObj = this.aodObjectFactory.get('SpecAd', pick(specAd, 'id', 'recordVersion'));

        const newSpecAd = await adObj.unLock();
        this.replaceSpecAdInSalesSheet(newSpecAd);
        return newSpecAd;
    },

    replaceSpecAdInSalesSheet: function(specAd, salesSheet) {

        if (! salesSheet) {
            const salesSheet = this.model.salesSheet.get(specAd.salesSheetId);
        }

        if (salesSheet) {
            replaceElement(salesSheet.specAds, specAd);
            salesSheet.recordVersion += 0.001 ;
            this.model.salesSheet.update(salesSheet);
        }

        return salesSheet;
    },


    //todo - resolve sirect react state vs model overlap...
    deleteSpecAd: async function(specAd, salesSheet){
        const saObj = this.aodObjectFactory.get('SpecAd', specAd);
        const result = await saObj.remove();

        if (! salesSheet) {
            const salesSheet = this.model.salesSheet.get(specAd.salesSheetId);
        }

        if (salesSheet) {
            //const ssObj = this.aodObjectFactory.get('SalesSheet', salesSheet);
            //const newSalesSheet = ssObj.get();
            //const ssResult = await this.aodService.itemCalls['salesSheet'].load(salesSheet.id);
            //const newSalesSheet = this.aodService.itemCalls['salesSheet'].getRecord(ssResult);

            // may have been already removed
            salesSheet.specAds = reject(salesSheet.specAds, {id: specAd.id});
            salesSheet.recordVersion += 0.001 ;
            this.model.salesSheet.update(salesSheet);
        }

        return salesSheet;
    },

    // todo ? support other files - web etc
    addFileToSpecAd: async function(specAd, pdfUrl){
        const saObj = this.aodObjectFactory.get('SpecAd', specAd);

        return await saObj.retrieveFile({
                url: pdfUrl,
                name: '',
                type: 'application/pdf' // todo !base on file
            },
            {
                isAsset: true,
                "fileClass" : "SPEC_AD",
                "fileType" : "MATERIAL"
            }
        );
    }
};